import { useState, useEffect } from "react";
import { inject, observer } from "mobx-react";

import { Card } from "primereact/card";

import { Dropdown } from "primereact/dropdown";
import InputNumberUI from "@UI/InputNumberUI";
import { Divider } from "primereact/divider";
import moment from "moment";
import { Button } from "primereact/button";

import "./style.scss";

const PositionCalculator = inject("mainStore")(
    observer(({ mainStore }) => {
        const [vendors, setVendors] = useState([]);
        const [offer, setOffer] = useState([]);
        const [rates, setRates] = useState([]);
        const [calculatedData, setCalculatedData] = useState({});
        const [isChanged, setIsChanged] = useState(false);
        const [data, setData] = useState({});

        const filterOfferDefault = data.vendorData && offer ? offer.filter((f) => f.vendorId === data.vendorData._id) : offer;
        const filterOffer = filterOfferDefault.map((i) => ({ ...i, title: i.title?.replace(/<\/?[^>]+(>|$)/g, "").replace(/\u00A0|&nbsp;/g, " ") }));

        const ratesFilter =
            data.offerData && data.offerData.ratesArray
                ? data.offerData.ratesArray
                      .map((item) => {
                          const rate = rates.find((r) => r._id === item.rateId && (!item.dateEnd || moment(item.dateEnd).isSameOrAfter(moment().subtract(1, "day"), "day")));
                          return rate ? { ...rate, ...item } : null;
                      })
                      .filter(Boolean)
                : [];

        useEffect(() => {
            getVendors();
            getOffer();
            getRates();
        }, []);

        const getVendors = async () => {
            const resp = await mainStore.getByUrl("/promo/suggest_list?collection=vendors&sortField=name&sortOrder=asc", false, "", false, false);
            if (resp && resp.success) {
                setVendors(resp.data.filter((el) => el.active));
            }
        };

        const getOffer = async () => {
            const resp = await mainStore.getByUrl(
                "/promo/suggest_list?collection=offers&project[title]=1&project[technicalName]=1&project[_id]=1&project[vendorId]=1&project[rateIds]=1&project[ratesArray]=1&project[code]=1&project[active]=1&project[dateStart]=1&project[dateEnd]=1&project[draft]=1&sortField=name&sortOrder=asc&filters[active]=true",
                false,
                "",
                false,
                false,
            );
            if (resp && resp.success) {
                setOffer(resp.data);
            }
        };

        const getRates = async () => {
            const resp = await mainStore.getByUrl("/promo/suggest_list?collection=rates", false, "", false, false);
            if (resp && resp.success) {
                setRates(resp.data);
            }
        };

        const updateDataField = (key, value) => {
            setCalculatedData({});
            setIsChanged(true);
            setData((prev) => {
                return { ...prev, [key]: value };
            });
        };

        const handleCalulate = async () => {
            setIsChanged(false);
            console.log({ offerId: data.offerData._id, newRate: data.newRate, oldRate: ratesFilter[0].rate, newFap: data.newFap, oldFap: data?.offerData?.forecastActivationPercent ?? 0 });
            const resp = await mainStore.postByUrl(
                `/promo/checkOfferPositionDifference`,
                { offerId: data.offerData._id, newRate: data.newRate, oldRate: ratesFilter[0].rate, newFap: data.newFap, oldFap: data?.offerData?.forecastActivationPercent ?? 0 },
                "",
                true,
                true,
            );
            if (resp && resp.data) {
                setCalculatedData(resp.data);
            }
        };

        const handleRest = () => {
            setCalculatedData({});
            setData((prev) => {
                return {
                    vendorData: prev.vendorData,
                    offerData: prev.offerData,
                };
            });
        };
        const isNotEmpty = Object.keys(calculatedData).length > 0;
        const isReset = isNotEmpty && !isChanged;

        return (
            <div className="position-calculator">
                <Card className="position-calculator__block" title={"Калькулятор средней позиции"}>
                    <div className="block__select">
                        <div className="wrapper">
                            <label className="label">Вендор</label>
                            <Dropdown
                                value={data.vendorData}
                                onChange={(e) => {
                                    updateDataField("vendorData", e.value);
                                    updateDataField("newRate", null);
                                    updateDataField("offerData", null);
                                }}
                                options={vendors ? vendors : []}
                                optionLabel="name"
                                placeholder="Выберите из списка"
                                className="dropdown"
                                filter
                                style={{ width: "100%" }}
                                emptyFilterMessage="Нет элементов для выбора"
                                emptyMessage="Нет элементов для выбора"
                            />
                        </div>

                        <div className="wrapper">
                            <label className="label">Оффер</label>
                            <Dropdown
                                value={data.offerData}
                                onChange={(e) => {
                                    updateDataField("offerData", e.value);
                                    updateDataField("newRate", null);
                                }}
                                options={filterOffer ? filterOffer : []}
                                optionLabel="title"
                                placeholder="Выберите из списка"
                                className="dropdown"
                                filter
                                style={{ width: "100%" }}
                                disabled={!data.vendorData}
                                emptyFilterMessage="Нет элементов для выбора"
                                emptyMessage="Нет элементов для выбора"
                            />
                        </div>
                    </div>
                </Card>

                {ratesFilter.length ? (
                    <>
                        <div className="position-calculator__cards">
                            <Card title="Укажите данные за выбранный период">
                                <div>
                                    {ratesFilter.map((el, key) => {
                                        const typeLabel = el?.item?.type === "cpl" ? "CPL" : tabItems.find((i) => i.key === el.cpoType)?.label;

                                        return (
                                            <div className="rates__item" key={key}>
                                                <div className="rates__item-date">
                                                    <span>Ставка</span>
                                                    <div className="date">
                                                        c {moment(el.dateStart).format("DD.MM.YYYY")} до {el.dateEnd ? moment(el.dateEnd).format("DD.MM.YYYY") : "∞"}
                                                    </div>
                                                </div>

                                                <div className="rates__item-element">
                                                    <span>{el.type.toUpperCase()}</span>

                                                    <div className={`item__label ${el.cpoType === "percentAmount" ? "yellow" : el.cpoType === "rateGradation" ? "blue" : el.type === "cpl" ? "cpl" : ""}`}>{typeLabel}</div>

                                                    {el.cpoType === "rateGradation" ? null : <div>{el.rate} ₽</div>}

                                                    <div className="multi__item-comment">{el.comments}</div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>

                                <Divider />
                                <div className="position-calculator__inputs">
                                    <InputNumberUI label="Прогнозный процент активаций" placeholder="0" value={data?.offerData?.forecastActivationPercent ?? 0} disabled />

                                    {fields.map(({ key, label }) => (
                                        <InputNumberUI key={key} label={label} placeholder="0" value={calculatedData.histData?.[key] ?? 0} disabled />
                                    ))}
                                </div>
                                <div className="position-calculator__results">
                                    <div className="position-calculator__stats">
                                        {primaryStats.map(({ title, key }) => (
                                            <div key={title} className="position-calculator__stat">
                                                <div className="position-calculator__stat-title">{title}</div>
                                                <div className="position-calculator__stat-value">{(calculatedData.histData?.[key] ?? 0) + "%"}</div>
                                            </div>
                                        ))}
                                    </div>

                                    <div className="position-calculator__stats position-calculator__stats_secondary">
                                        {secondaryStats.map(({ title, key, addClass }) => (
                                            <div key={title} className={`position-calculator__stat ${addClass}`}>
                                                <div className="position-calculator__stat-title">{title}</div>
                                                <div className="position-calculator__stat-value">{calculatedData.histData?.[key] ?? 0}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Card>
                            <Card title="Расчет новых данных">
                                <div className="position-calculator__calc">
                                    <InputNumberUI
                                        label="Укажите новую гипотетическую ставку*"
                                        placeholder="Укажите сумму без НДС"
                                        value={data.newRate}
                                        onValueChange={(e) => {
                                            updateDataField("newRate", e.value);
                                        }}
                                        locale="ru-RU"
                                        minFractionDigits={0}
                                        maxFractionDigits={2}
                                        min={0}
                                        max={9999999999999999}
                                    />

                                    <Divider />
                                    <div className="position-calculator__inputs">
                                        <InputNumberUI
                                            className="position-calculator__percent"
                                            label="«Прогнозный процент активаций» новый"
                                            placeholder="0"
                                            value={data.newFap}
                                            onValueChange={(e) => {
                                                updateDataField("newFap", e.value);
                                            }}
                                            locale="ru-RU"
                                            minFractionDigits={0}
                                            maxFractionDigits={2}
                                            min={0}
                                            max={9999999999999999}
                                        />
                                        {newFields.map(({ key, label }) => (
                                            <InputNumberUI key={key} label={label} placeholder="0" value={calculatedData.newData?.[key] ?? 0} disabled />
                                        ))}
                                    </div>
                                    <div className="position-calculator__results">
                                        <div className="position-calculator__stats">
                                            {primaryStats.map(({ title, key }) => (
                                                <div key={title} className="position-calculator__stat">
                                                    <div className="position-calculator__stat-title">{title}</div>
                                                    <div className="position-calculator__stat-value">{(calculatedData.histData?.[key] ?? 0) + "%"}</div>
                                                </div>
                                            ))}
                                        </div>

                                        <div className="position-calculator__stats position-calculator__stats_secondary">
                                            {newSecondaryStats.map(({ title, key, addClass }) => (
                                                <div key={title} className={`position-calculator__stat ${addClass}`}>
                                                    <div className="position-calculator__stat-title">{title}</div>
                                                    <div className="position-calculator__stat-value">{calculatedData.newData?.[key] ?? 0}</div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        </div>

                        <Button label={isReset ? "Сбросить все данные" : isNotEmpty ? "Пересчитать" : "Рассчитать"} severity={isReset ? "danger" : "success"} onClick={isReset ? handleRest : handleCalulate} disabled={!isReset && !data.newRate} />
                    </>
                ) : null}
            </div>
        );
    }),
);

const fields = [
    { key: "views", label: "Показы" },
    { key: "clicks", label: "Клики" },
    { key: "getOffer", label: "«Получить предложение»" },
    { key: "activations", label: "Активации промокодов" },
];

const newFields = [
    { key: "predictedViews", label: "Показы новые" },
    { key: "predictedClicks", label: "Клики новые" },
    { key: "predictedGetOffer", label: "«Получить предложение» новые" },
    { key: "predictedActivations", label: "Активации промокодов новые" },
];

const primaryStats = [
    { title: "CR в Клик", key: "ctr" },
    { title: "CR в «Получить предложение»", key: "toGetOfferConversionPercent" },
    { title: "Конверсия в активацию", key: "activationPercent" },
];

const secondaryStats = [
    { title: "RPM", key: "historicalRpm" },
    { title: "Средняя позиция", key: "avg_position", addClass: "position-calculator__stat_avg-pos" },
];

const newSecondaryStats = [
    { title: "RPM", key: "newRpm" },
    { title: "Средняя позиция", key: "newAvgPos", addClass: "position-calculator__stat_avg-pos" },
];

const tabItems = [
    { key: "percentAmount", label: "Процент" },
    { key: "fixedAmount", label: "Фикс" },
    { key: "rateGradation", label: "Градация" },
];

export default PositionCalculator;
